import { default as Whenfin } from "./Whenfin.js";
import { default as FileCompressor } from "./FileCompressor.js";
import { default as Loopster } from "./Loopster.js";
import { default as Blackbox } from "./Blackbox.js";
import { default as DistributedComputing } from "./DistributedComputing.js";
export const readmes = {
  Whenfin: Whenfin,
  FileCompressor: FileCompressor,
  Loopster: Loopster,
  Blackbox: Blackbox,
  DistributedComputing: DistributedComputing,
};
